import React from 'react';
import { Link } from 'fw/components/formatter/Formatter';

class DiscountCodeLink extends React.Component {
	handleClick = (e) => {
		e.stopPropagation();
		return false;
	}

	_getLinkValue() {
		if (this.props.value) {
			var url = `/admin/discountCodeSetup/${this.props.dependentValues.discountCodeId}`;

			return {
				url: url,
				title: this.props.value
			};
		}
		else return null;
	}

	render() {
		if (this.props.value)
			return <Link value={this._getLinkValue()}></Link>

		return null
	}
}

export default DiscountCodeLink;


// WEBPACK FOOTER //
// ./src/areas/shared/components/formatter/DiscountCodeLink.js